export class EventEmitter {
  constructor() {
    this._events = Object.create(null);
  }

  // Подписка на событие
  $on(event, handler) {
    if (!this._events[event]) {
      this._events[event] = [];
    }
    this._events[event].push(handler);
    // console.log('on', event, this._events[event].length, this._events[event])
  }

  // Отписка от события
  $off(event, handler) {
    if (this._events[event]) {
      this._events[event] = this._events[event].filter(h => h !== handler);
      // console.log('off', event, this._events[event].length, handler)
      if (this._events[event].length === 0) {
        delete this._events[event];
      }
    }
  }

  // Отправка события
  $emit(event, payload) {
    if (this._events[event]) {
      this._events[event].forEach(handler => {
        try {
          handler(payload);
        } catch (error) {
          // console.error(`Ошибка в обработчике события "${event}":`, error);
        }
      });
    }
  }
}
